import cn from 'classnames'

export default function AwesomeIcon({ prefix, icon, className }) {
  const styles = cn(prefix, 'fa-' + icon, className)
  return (
    <i className={styles} />
  )
}
